const { VITE_PAYPAL_CLIENT_ID } = import.meta.env;

const config = {
  PAYPAL_OPTIONS: {
    "client-id": VITE_PAYPAL_CLIENT_ID,
    "disable-funding": "paylater,credit",
    // "enable-funding": "venmo",
    "currency": "USD",
    "locale": "en_US"
  }
}

export default config;